<template>
  <div class="h-dialogContainer">
    <div>
      <MemberInfoCommon ref="memeberConfigInfo" opCode="addMemeber" impugrpclassIndex="6" impugrppriorityIndex="7" grppropertyIndex="8" :msgid="msgid" :neid="neid"></MemberInfoCommon>
    </div>
    <div class="h-borderBox h100vh-474">
      <div class="h-subscriber-member-qryParamDiv">
        <div class='row h-row-inputBox'>
          <div class='col-sm-3 h-col-inputBox'>
            <div class='h-inputLit'>{{$t('SubscriberIms.groupNo')}}:</div>
            <ejs-textbox ref="groupnumParam"></ejs-textbox>
          </div>
          <div class='col-sm-3 h-col-inputBox'>
            <div class='h-inputLit'>{{$t('SubscriberIms.groupName')}}:</div>
            <ejs-textbox ref="groupnameParam"></ejs-textbox>
          </div>
          <div class='col-sm-3 h-col-inputBox'>
            <div class='h-inputLit'>{{$t('SubscriberIms.vpnid')}}</div>
            <ejs-textbox ref="groupvpnParam" disabled="true" ></ejs-textbox>
            <div class='h-subscribe-select-style'>
              <ejs-button :isPrimary="true" @click.native="getVpnInfo">{{$t('SubscriberIms.selectVButton')}}</ejs-button>
            </div>
          </div>
          <div class='col-sm-3'>
            <div class='h-inputLit'></div>
            <div class='h-subscriber-member-qryButton'>
             <!-- <ejs-button :isPrimary="true" @click.native="getVpnInfo">{{$t('SubscriberIms.selectVButton')}}</ejs-button>-->
              <ejs-button :isPrimary="true" @click.native="qryDialog">{{$t('SubscriberIms.find')}}</ejs-button>
            </div>
          </div>
        </div>
      </div>
      <ejs-grid ref='grid' :dataSource="data" :allowResizing='true':allowPaging='true' :pageSettings="page" height="calc(100% - 0px)">
        <e-columns>
          <e-column type='checkbox':headerText="$t('SubscriberIms.groupNo')" width='30' textAlign='Center'></e-column>
          <e-column field='grpnum' :headerText="$t('SubscriberIms.groupNo')" width='60' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
          <e-column field='grpname' :headerText="$t('SubscriberIms.groupName')" width='60' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
          <e-column field='grptype' :headerText="$t('SubscriberIms.groupType')" :formatter='grptypeFormat' width='60' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
          <e-column field='grpproperty' :headerText="$t('SubscriberIms.grpAttribute')" :formatter='grppropertyFormat' width='60' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
        </e-columns>
      </ejs-grid>
      <ejs-pager ref="userMemberPager"  @click='getGridData(node,vpnclassBak,qryParamBak, false)' :currentPage='page.pageNo' :pageSize='page.pageSize' :totalRecordsCount='page.totalCount'></ejs-pager>
      <CustomDialog ref='qryVpnInfoPage' :element='dialog.element.eleQryVpnInfo' :styles='dialog.vpnstyles'>
        <template v-slot:dialog-content>
          <OrganizationalTree ref="organizationalTreeInner" :neid="neid" :vpndata="vpndata" :existFlag="false" :disableNodes="disableNode"></OrganizationalTree>
        </template>
      </CustomDialog>
    </div>
  </div>
</template>

<script>
import MemberInfoCommon from '../../MemberInfoCommon';
import OrganizationalTree from '../../../util/OrganizationalTree';
import CustomDialog from '../../../../common/CustomDialog';
import { EventBus } from '../../../../../plugins/eventBus';
import { Resize } from '@syncfusion/ej2-vue-grids';

export default {
  name: 'AddUserMemberDialog',
  components: {
    MemberInfoCommon,
    OrganizationalTree,
    CustomDialog,
  },
  provide: {
    grid: [Resize]
  },
  props: [
    'opCode',
    'msgid',
    'neid',
    'node',
  ],
  data() {
    return {
      data: {},
      memberInfo: {},
      checkedData: [],
      vpndata: [],
      disableNode:[],
      qryParamBak:undefined,
      vpnclassBak:undefined,
      page: {
        pageNo: 1,
        pageSize: 20,
        totalCount: '0',
        pageCount: '0',
      },
      neid:'',
      info: {
        msgid: '',
        neid: '',
        netype: 'p_hss',
        neversion: ''
      },
      vo: {
        flag: '',
        vpnid: '',
        vpnClass: ''
      },
      chooseCount: 0,
      gridTypeEnum: {
        grptype: [this.$t('SubscriberIms.grptype0'),this.$t('SubscriberIms.grptype1'),this.$t('SubscriberIms.grptype2'),this.$t('SubscriberIms.grptype3'),this.$t('SubscriberIms.grptype4')],
        grpproperty:[this.$t('SubscriberIms.grpproperty0'),this.$t('SubscriberIms.grpproperty1')]
      },
      dialog: {
        element: {
          eleQryVpnInfo: {
            target: this.$refs.qryVpnInfoPage,
            refName: 'qryVpninfo',
            buttonGroup: [
              {
                click: this.closeQryVpnInfoPage, buttonModel: {content: this.$t('SubscriberIms.cancel')}
              },
              {
                click: this.setChooseVpnInfo, buttonModel: {content: this.$t('SubscriberIms.confirm'), isPrimary: true}
              }
            ],
            title: this.$t('SubscriberIms.organization'),
            isClose: true
          }
        },
        vpnstyles: {
          width: '20%',
          height: '48%',
          zIndex: 1000,
          visible: false,
          model: true
        },
      }
    };
  },

  methods: {
    grptypeFormat(grids,data){
      return this.gridTypeEnum.grptype[data.grptype];
    },
    grppropertyFormat(grids,data){
      return this.gridTypeEnum.grpproperty[data.grpproperty];
    },
    mainHandler() {
      const vpntree = this.$parent.$parent.$parent.$refs.addUserMember.$parent.$parent.$parent.$parent.$parent.$refs.organizationalTree;
      this.vpndata = vpntree.initData;
      this.disableNode = vpntree.disableNode;
      this.$refs.memeberConfigInfo.mainHandler([], { opCode: 'add' },true);
    },
    getDatas() {
      const validateReturn = this.$refs.base.validateResult() === false ? this.$refs.base.validateResult() : true;
      if (!validateReturn) {
        console.log('表单验证不通过');
        return;
      }
      const map = this.$refs.base.getDatas();
      // 隶属关系完整数据
      console.log(map);
    },
    getChooseCount() {
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      this.chooseCount = selectedRecords.length;
    },
    getCheckedData() {

      const groupList = this.$refs.grid.getSelectedRecords();
      const memberInfo = this.$refs.memeberConfigInfo.getMemberInfo();
      console.log("======================",memberInfo);
      const grppropertyMap = memberInfo.get('grpproperty').valueMap;
      const map = new Map();
      console.log(grppropertyMap);
      groupList.map(item => {
        // item.grpproperty = grppropertyMap.get();
        console.log(item.grpproperty);
      })
      return groupList;
    },
    initAnotherBussinessDatas(datas) {
      datas.confirmpassword = datas.password;
    },
    qryDialog() {
      const neid  = this.neid;
      const param = {
        grpnum: this.$refs.groupnumParam.ej2Instances.value,
        grpname: this.$refs.groupnameParam.ej2Instances.value,
        vpnid: this.$refs.groupvpnParam.ej2Instances.value,
        grptype: -1,
        //userenable: -1,
      };
     let vpnNode = null;
     let vpnclass =0;
      const queryByIdParam = {};
      queryByIdParam.vpnid = param.vpnid;
      queryByIdParam.flag = 1;
      if(param.vpnid != 0 && param.vpnid != null){
        this.$axios.post('/lte/ems/subscriber/imsunms/requestCommon',
          { vo: queryByIdParam,
            info: { msgid: 27806, neid },
            page: { pageNo: 1, pageSize: 1 }
          }).then(response => {
          vpnNode = response.data.resultVal.resultList[0];
          if(vpnNode.vpnclass6 != 0 && vpnNode.vpnclass6 != null)
          {vpnclass = 6;}
          else if(vpnNode.vpnclass5 != 0 && vpnNode.vpnclass5 != null)
          {vpnclass =5;}
          else if(vpnNode.vpnclass4 != 0 && vpnNode.vpnclass4 != null)
          {vpnclass =4;}
          else if(vpnNode.vpnclass3 != 0 && vpnNode.vpnclass3 != null)
          {vpnclass =3;}
          else if(vpnNode.vpnclass2 != 0 && vpnNode.vpnclass2 != null)
          {vpnclass =2;}
          else if(vpnNode.vpnclass1 != 0 && vpnNode.vpnclass1 != null)
          {vpnclass =1;}
          else
          {vpnclass = 0;}
          this.qryParamBak = param;
          this.vpnclassBak = vpnclass;
          this.getGridData(this.node,vpnclass, param,true);
        });
      }
      else{
        this.qryParamBak = param;
        this.vpnclassBak = vpnclass;
        this.getGridData(this.node,vpnclass, param,true);
      }
    },
    getGridData(node, vpnclass = undefined,qryParam = undefined,searchFlag = false) {
      console.log('qryParam',qryParam);
      if(searchFlag) {
        //不清楚吕大神，为什么加上以下判断。通过分析，应该是隶属关系也模糊查询时增加以下判断，待验证。
        if(qryParam == undefined || qryParam.vpnid == "" || qryParam.vpnid == null)
        {
          return;
        }
      }
      const $this = this;
      if (node !== '') {
        $this.node = node;
        const array = node.id.split('_');
        const neid = array[0];
        //const vpnid = array[2];
        $this.info.neid = neid;
        $this.info.vpnid = 0;
        $this.info.vpnname = node.text;
        $this.info.msgid = '27826';
        //const vpnclass = parseInt($this.node.level, 0) - 1;
        $this.info.vpnClass = vpnclass;
        $this.vo.vpnid = 0;
        $this.vo.vpnClass = vpnclass;
        $this.vo.flag = 0;
        $this.vo.vpnname = node.text;
        const paramVo = $this.vo;
        if (qryParam !== undefined) {
          paramVo.flag = 2;
          for (const _param in qryParam) {
            paramVo[_param] = qryParam[_param];
          }
          if(searchFlag)
            $this.page.pageNo = 1;
          else
            $this.page.pageNo = $this.$refs.userMemberPager.ej2Instances.currentPage;
        }
        else
          $this.page.pageNo = $this.$refs.userMemberPager.ej2Instances.currentPage;
        const paramTotal = {
          vo: $this.vo,
          info: {
            msgid: 27826,
            neid: $this.neid
          },
          page: $this.page
        };
        // const pageInfo = { pageNo: $this.page.pageNo, pageSize: $this.page.pageSize };
        // 需要拼装vo info
        // this.$axios.post('lte/ems/ims/subscriber/requestCommon', $this.getParams(pageInfo)).then((response) => {
        this.$axios.post('/lte/ems/subscriber/imsunms/requestCommon', paramTotal).then((response) => {
          const res = response.data.resultVal;
          console.log(res);
          if (res.resultList === undefined) {
            $this.data = [];
            $this.page.pageCount = 0;
            $this.page.totalCount = 0;
            $this.page.pageCount = 0;
            $this.$refs.grid.clearSelection();
            return;
          }
          res.resultList.forEach(item => {
            const time = item.createtime * 1000;
            item.createtime = time;
          });
          res.resultList.forEach(item => {
            item.impugrpclass = '请求话权权限/话权排队权限/话权抢占权限';
            item.impugrpclass_hidden = [1, 1, 1];
            item.impugrppriority = 0;
            //item.grpproperty = 3;
          });
          $this.data = res.resultList;
          //$this.page.pageCount = res.page;
          $this.page.totalCount = res.countrsp;
          //$this.page.pageCount = Math.ceil(res.countrsp / $this.page.pageSize);
          $this.$refs.grid.clearSelection();
        });
      } else {
        $this.info.neid = '';
        $this.info.vpnid = '';
        $this.info.vpnname = '';
      }
    },
    getVpnInfo(){
      console.log('get vpninfo',this.neid);
      this.$refs.organizationalTreeInner.staDoFieldsList = this.vpndata;
      this.$refs.qryVpnInfoPage.show();
      this.$refs.organizationalTreeInner.getOrganizationalTreeWithNeid();
      return;
    },
    setChooseVpnInfo(event) {
      if (event.keyCode === 13) {
        return;
      }
      const selectNode = this.$refs.organizationalTreeInner.getNode();
      if (!selectNode) {
        EventBus.$emit('toast', { type: 'warning', content:this.$t('SubscriberIms.chooseNodeTip')});
      } else {
        this.$refs.organizationalTreeInner.clear();
        this.$refs.qryVpnInfoPage.clear();
        this.$refs.qryVpnInfoPage.close();
        //this.$refs.impuinfo.$refs.bus.getRefObj('vpnid').value=selectNode.text;
        //this.info.vpnid = selectNode.id.split('_')[2];
        this.$refs.groupvpnParam.ej2Instances.value = selectNode.id.split('_')[2];
      }
    },
    closeQryVpnInfoPage() {
      this.$refs.organizationalTreeInner.clear();
      this.$refs.qryVpnInfoPage.clear();
      this.$refs.qryVpnInfoPage.close();
    },
  },
};
</script>
<style scoped>

</style>
